import React from "react";
import { Grid, Section, Typography } from "../../core";
import { Space } from "antd";
import styled from "styled-components";
import companyLogo from "../../assets/images/logo.png";
import { getDateInDashFormat } from "../../helper/utils/genericAction";
const Container = styled.div`
  width: 90%;
  h3 {
    font-size: 24px;
    line-height: 36px;
    font-weight: bold;
    color: #233b67;
    margin: 0px;
    text-transform: capitalize;
  }
  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #233b67;
    margin: 0px;
    text-transform: capitalize;
  }
  span {
    font-weight: bold;
    text-transform: capitalize;
  }
`;
const StyledDivider = styled.div`
  width: 150px;
  height: 2px;
  border-top: 1px solid #233b67;
`;
const Image = styled.img`
  width: 70%;
`;

const IncoiceLetter = ({ className, children, state, ...props }) => {
  let { companyDetail, contractDetails, inVoiceData } = state;
  console.log("state=>", state);
  return (
    <Section className={className} radius="10px 10px 0px 0px">
      <div>
        <div className="d-flex dir-columns">
          <div style={{ minHeight: "60mm" }}>
            <Grid>
              <div className="d-flex h-between">
                <div style={{ width: "50%" }}>
                  {companyDetail && companyDetail.companyLogo ? (
                    <Image src={companyLogo} alt="" />
                  ) : (
                    <Typography
                      color="#233b67"
                      lineHeight="initial"
                      as="h1"
                      weight="bold"
                      noMargin
                      fontSize="34px"
                    >
                      {companyDetail &&
                        companyDetail.companyName &&
                        companyDetail.companyName}
                    </Typography>
                  )}
                  <Container>
                    <h3>Buyer Information</h3>
                    <p>
                      <span>Company Name : </span>
                      {contractDetails &&
                        contractDetails.buyerCompanyId &&
                        contractDetails.buyerCompanyId.companyName &&
                        contractDetails.buyerCompanyId.companyName}
                    </p>

                    <p>
                      <span>Buyer Address :</span>
                      {contractDetails &&
                        contractDetails.buyerCompanyId &&
                        contractDetails.buyerCompanyId.companyAddress &&
                        contractDetails.buyerCompanyId.companyAddress}
                    </p>
                    <p>
                      <span>Phone Number : </span>
                      {contractDetails &&
                        contractDetails.buyerCompanyId &&
                        contractDetails.buyerCompanyId.phoneNumber &&
                        contractDetails.buyerCompanyId.phoneNumber}
                    </p>
                    <p>
                      <span>NTN : </span>
                      {contractDetails &&
                        contractDetails.buyerCompanyId &&
                        contractDetails.buyerCompanyId.NTN &&
                        contractDetails.buyerCompanyId.NTN}
                    </p>
                    <p>
                      <span>STRN : </span>
                      {contractDetails &&
                        contractDetails.buyerCompanyId &&
                        contractDetails.buyerCompanyId.STRN &&
                        contractDetails.buyerCompanyId.STRN}
                    </p>
                  </Container>
                </div>

                <div style={{ width: "50%" }}>
                  <Container>
                    <p>
                      <span>Company Address : </span>
                      {companyDetail &&
                        companyDetail.companyAddress &&
                        companyDetail.companyAddress}
                    </p>
                    <p>
                      <p>
                        <span>Phone Number : </span>
                        {companyDetail &&
                          companyDetail.phoneNumber &&
                          companyDetail.phoneNumber}
                      </p>
                      <span>NTN : </span>
                      {companyDetail && companyDetail.NTN && companyDetail.NTN}
                    </p>
                    <p>
                      <span>STRN : </span>
                      {companyDetail &&
                        companyDetail.STRN &&
                        companyDetail.STRN}
                    </p>
                  </Container>

                  <Container>
                    <h3>Invoice</h3>
                    <p>
                      <span>Invoice No : </span>
                      {inVoiceData &&
                        inVoiceData.invoiceNumber &&
                        inVoiceData.invoiceNumber}
                    </p>
                    <p>
                      <span>Invoice Date : </span>
                      {getDateInDashFormat(
                        inVoiceData &&
                          inVoiceData.invoiceDate &&
                          inVoiceData.invoiceDate
                      )}
                    </p>
                  </Container>
                </div>
              </div>
            </Grid>
          </div>
          {children}
        </div>
        <div style={{ height: "60mm" }}>
          <div className="d-flex h-between v-center h-100">
            <div>
              <div className="d-flex v-center">
                <Space>
                  <Typography
                    as="span"
                    weight="bold"
                    color="#233B67"
                    fontSize="12px"
                  >
                    Prepared By :
                  </Typography>
                  <StyledDivider></StyledDivider>
                </Space>
              </div>
              <div className="mt-30 d-flex v-center">
                <Space>
                  <Typography
                    as="span"
                    color="#233B67"
                    weight="bold"
                    fontSize="12px"
                  >
                    Checked By :
                  </Typography>
                  <StyledDivider orientation="left"></StyledDivider>
                </Space>
              </div>
            </div>
            <div>
              <StyledDivider
                style={{ width: "200px", margin: "5px 0px !important" }}
              />
              <Typography
                align="center"
                as="h6"
                color="#233B67"
                weight="bold"
                fontSize="12px"
              >
                Signature
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default IncoiceLetter;
